import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { DialogLocationsGroupsComponent } from './dialog-locations-groups.component';
import { TabLocationsGroupsComponent } from './tabs/locations-groups/tab-locations-groups.component';

@NgModule({
  entryComponents: [
    DialogLocationsGroupsComponent
  ],
  declarations: [
    DialogLocationsGroupsComponent,
    TabLocationsGroupsComponent
  ],
  exports: [
    DialogLocationsGroupsComponent
  ],
  imports: [
    CommonModule,

    MatTooltipModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatTabsModule,
    TranslateModule,

    FuseSharedModule,
    FuseSidebarModule,
    DisclaimerModule
  ]
})
export class DialogLocationsGroupsModule { }
